
export const parsingPlatformText = (platforms?: string[]) => {
  if (!platforms) return "게임의 플랫폼을 선택해 주세요.";

  if (platforms.includes("MOBILE") && platforms.includes("PC")) {
    return "모바일 + PC";
  } else if (platforms.includes("MOBILE")) {
    return "모바일";
  } else if (platforms.includes("PC")) {
    return "PC";
  } else {
    return "게임의 플랫폼을 선택해 주세요.";
  }
} 